import apiClient from './apiClient'; // Import the proper API client

export interface City {
  id: number;
  name: string;
  ascii_name: string;
  state_id: string;
  state_name: string;
  lat: number;
  lng: number;
  population: number;
  timezone: string;
}

export interface State {
  id: string;
  name: string;
}

export interface GeocodedCity {
  name: string;
  state_name: string;
  country: string;
  lat: number;
  lng: number;
  lat_start?: number;
  long_start?: number;
  lat_end?: number;
  long_end?: number;
  display_name: string;
}

export const searchCities = async (
  nameQuery: string,
  stateId?: string,
  limit = 10,
  skip = 0
): Promise<City[]> => {
  try {
    // Use the apiClient instead of the generic api client
    const response = await apiClient.get('/cities', {
      params: {
        name_query: nameQuery,
        state_id: stateId,
        limit,
        skip
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error searching cities:', error);
    return [];
  }
};

export const getCityById = async (cityId: number): Promise<City | null> => {
  try {
    const response = await apiClient.get(`/cities/${cityId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching city:', error);
    return null;
  }
};

export const getCitiesByLocation = async (
  lat: number,
  lng: number,
  radius = 50,
  limit = 10
): Promise<City[]> => {
  try {
    const response = await apiClient.get('/cities/by-location', {
      params: {
        lat,
        lng,
        radius,
        limit
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error fetching cities by location:', error);
    return [];
  }
};

export const getStates = async (): Promise<State[]> => {
  try {
    const response = await apiClient.get('/cities/states');
    return response.data;
  } catch (error) {
    console.error('Error fetching states:', error);
    return [];
  }
};

export const getCitiesNearLocation = async (
  lat: number, 
  lng: number, 
  radius: number = 50, 
  limit: number = 10
): Promise<City[]> => {
  const response = await apiClient.get(
    `/cities/by-location?lat=${lat}&lng=${lng}&radius=${radius}&limit=${limit}`
  );
  return response.data;
};

export const geocodeCity = async (
  cityName: string,
  stateName: string,
  country: string
): Promise<GeocodedCity> => {
  const response = await apiClient.get(
    `/cities/geocode?city_name=${encodeURIComponent(cityName)}&state_name=${encodeURIComponent(stateName)}&country=${encodeURIComponent(country)}`
  );
  return response.data;
}; 